import { FC } from 'react';
import { Card, Icon, Typography } from '@sravni/react-design-system';
import { Tip } from '@sravni/react-icons';
import styles from './styles.module.scss';

const { Text } = Typography;

export const NotRequiredAlert: FC = () => (
    <Card color="green" className={styles.alertContainer}>
        <Icon color="green" size={28} shape="circle" className={styles.icon}>
            <Tip />
        </Icon>
        <div className={styles.text}>
            <Text size={14} strong className={styles.title}>
                Поля ниже заполнять необязательно
            </Text>
            <Text size={12} className={styles.description}>
                Но чем больше вы заполните, тем точнее мы посчитаем
            </Text>
        </div>
    </Card>
);
